export class DocumentFileLanguage {
  DocumentFileLanguageId: number;
  DocumentFileId: number;
  LanguageId: number;
}
